var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLinkedin = function SvgIconLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.649 2.14A1.622 1.622 0 0 1 2.315.568a1.622 1.622 0 0 1 1.666 1.57A1.622 1.622 0 0 1 2.315 3.7 1.622 1.622 0 0 1 .65 2.139Zm3.126 2.782H.825v8.884h2.95V4.922Zm10.65 3.87c0-1.92-.594-4.098-3.429-4.098A2.949 2.949 0 0 0 8.36 6.05V4.922H5.411v8.884h2.95V8.94c0-1.308.792-1.89 1.603-1.89.918 0 1.511.703 1.511 2.178v4.578h2.95V8.793Z",
    fill: "#fff"
  })));
};
export default SvgIconLinkedin;